var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "container"
  }, [_vm.user.email ? _c('h3', [_vm._v("User: " + _vm._s(_vm.user.email))]) : _vm._e(), _c('user-card', {
    attrs: {
      "user": _vm.user
    }
  }), _c('events-card'), _c('teams-card'), _c('playgrounds-card', {
    attrs: {
      "playgrounds": _vm.userPlaygrounds,
      "loading": _vm.loading.userPlaygrounds,
      "title": "User Playgrounds"
    },
    on: {
      "refresh": _vm.refreshPlaygrounds
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }